import { useRef } from "react";

/**
 * Runs `onReset` during render whenever `key` changes to a new non-null value.
 * Replaces the common `prevRef` pattern used in sheets to reset local state
 * when the sheet's identity (e.g. issueId) changes.
 */
export function useResetOnChange(key: string | null, onReset: () => void) {
  const prevRef = useRef<string | null>(null);
  if (key && key !== prevRef.current) {
    prevRef.current = key;
    onReset();
  }
}
